import React from "react";
import Chatwindow from "../Components/Chatwindow/Chatwindow";
import "./chat.css";
const Chat = () => {
  return (
    <>
      {/* <div className="container"> */}
      <div className="chatbox">
        <Chatwindow />
      </div>
      {/* </div> */}
    </>
  );
};

export default Chat;
